import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  arrowWrapper: {
    position: 'relative'
  },
  arrow: {
    width: 48,
    position: 'absolute',
    top: '40%',
    cursor: 'cursor'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/StartPage/Latest/icons/styles.js